import { create } from 'zustand';

export const useSelectedMpProductsStore = create((set, get) => ({
  // État initial
  selectedMpProducts: [],

  // Actions
  addSelectedMpProducts: (newSelectedMpProducts) =>
    set({
      selectedMpProducts: [
        ...get().selectedMpProducts,
        ...newSelectedMpProducts,
      ],
    }),

  removeSelectedMpProduct: (id) =>
    set({
      selectedMpProducts: get().selectedMpProducts.filter(
        (mpProduct) => mpProduct.id !== id
      ),
    }),

  updateSelectedMpProducts: (newSelectedMpProducts) =>
    set({
      selectedMpProducts: [...newSelectedMpProducts],
    }),

  clearSelectedMpProducts: () => set({ selectedMpProducts: [] }),

  getSelectedMpProducts: () => get().selectedMpProducts,

  isSelectedMpProductsLoaded: () => Array.isArray(get().selectedMpProducts),

  // Vérifie si un mpProduct est sélectionné par son id
  isMpProductSelected: (id) =>
    get().selectedMpProducts.some((mpProduct) => mpProduct.id === id),

  // Récupère les ids des mpProducts sélectionnés
  getSelectedMpProductIds: () =>
    get().selectedMpProducts.map((mpProduct) => mpProduct.id),
}));
